import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';

export const getEmployee = async (
	employeeId: string,
): Promise<AxiosResponse> => {
	return await companiesApi.get(`/employees/${employeeId}`);
};

export const getJobProfiles = async () => {
	return await companiesApi.get('/job-profiles');
};

export const getExposureAreas = async () => {
	return await companiesApi.get('/job-profiles');
};
